import { angular, app } from '../../app.module'
app
  // 上までスクロールするボタン
  .directive('scrollTopButton', () => {
    return {
      restrict: 'E',
      template: require('./scroll-top-button.pug')(),
      controller: function ($scope, $window, $element) {
        const window = angular.element($window)
        const thisElement = angular.element($element)

        // スクロール量に応じてボタンを表示
        window.scroll(() => {
          if (window.scrollTop() > 300) {
            thisElement.fadeIn()
          } else {
            thisElement.fadeOut()
          }
        })

        // ボタンクリック時にスクロール量を初期化
        $scope.scrollTop = function () {
          window.scrollTop(0)
        }
      },
    }
  })
